<template>
  <div
    v-if="props.isOpenList"
    class="settings-item"
  >
    <ul class="settings-item__list">
      <ListItem
        v-for="(listItem, i) in politicalType"
        :key="i"
        v-model="newsFeedStore.filterPoliticalAffiliation.value"
        :use-radio="true"
        :item="listItem.id"
        class="settings-item__list-item"
        @update:model-value="type => selectPoliticalType(type)"
      >
        {{ listItem.label }}
      </ListItem>
    </ul>
  </div>
</template>
<script setup>
import {defineProps} from "vue";
import { useNewsFeedStore } from "@/store/NewsFeed/newsFeed";
import { t } from "@/controllerLK/AvalLocalization";
import {debounce} from "@/functions/debouncer";

const props = defineProps({
  isOpenList: {
    type: Boolean,
    default: false,
  }
});

const politicalType = [
  {
    id: "not_chosen",
    label: t("settings_item_political.type.not_chosen")
  },
  {
    id: "government",
    label: t("settings_item_political.type.government")
  },
  {
    id: "neutral",
    label: t("settings_item_political.type.neutral")
  },
  {
    id: "opposition",
    label: t("settings_item_political.type.opposition")
  }
];

const newsFeedStore = useNewsFeedStore();

// Список ИД тегов политического типа.
const idList = {
  prod: {
    government: 3424733904,
    neutral: 976225014,
    opposition: 4121658613
  },
  stage: {
    government: 2666402901,
    neutral: 3870399970,
    opposition: 887681233
  },
  dev: {
    government: 2666402901,
    neutral: 3870399970,
    opposition: 887681233
  }
};

// Функция определения окружения
const getEnvironment = () => {
  const hostname = window.location.hostname;

  if (hostname === "avl-ai.ru") {
    return "prod";
  } else if (hostname === "stage.avl-ai.ru") {
    return "stage";
  } else if (hostname === "dev.avl-ai.ru") {
    return "dev";
  }

  // По умолчанию для локальной разработки используем dev
  return "dev";
};

// Получаем все ID политических тегов для всех окружений
const getAllPoliticalTagIds = () => {
  const allIds = [];
  Object.values(idList).forEach(env => {
    allIds.push(...Object.values(env));
  });
  return allIds;
};

// Функция. Выбора политического тега
const selectPoliticalType = async (type) => {
  const allPoliticalIds = getAllPoliticalTagIds();

  // Удаляем все политические теги из списка
  newsFeedStore.filterTags.listID = newsFeedStore.filterTags.listID.filter(
    id => !allPoliticalIds.includes(id)
  );

  // Если выбран not_chosen, не добавляем никакой тег
  if (type !== "not_chosen") {
    const env = getEnvironment();
    const selectedTagId = idList[env][type];
    newsFeedStore.filterTags.listID.push(selectedTagId);
  }

  await updateNewsDebounce();
};

// Функция. Обновление новостей
const updateNews = async () => {
  newsFeedStore.clearNewsFeed();
  await newsFeedStore.getNews();
};
const updateNewsDebounce = debounce(updateNews, 700);
</script>

<style lang="scss" scoped>
.settings-item {
  display: flex;
  flex-direction: column;
  gap: 10px;

  :deep(.radio-button) {
    justify-content: center;
  }

  &__list {
    &.scroll {
      max-height: 300px;
      overflow-x: hidden;
    }
  }

  &__list-item {
    height: 30px;
  }
}
</style>